'use strict'

module.exports = Backbone.View.extend
  render: (html) ->
    @$el.html(html?.calendarHtml)
    @$el.append(html?.html)
